"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const uicon_doc_plus_fill_style_1 = __importDefault(require("./uicon.doc.plus.fill.style"));
class UiconDocPlusFill extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.render = () => {
            const { classes, size } = this.props;
            return (jsx_runtime_1.jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", fillRule: "evenodd", viewBox: "0 0 32 32", "aria-hidden": "true", className: classes.root, style: { width: size, height: size } }, { children: jsx_runtime_1.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M27.3 9.00015V8.88022C27.3 8.7945 27.2831 8.70963 27.2501 8.63051C27.2172 8.55138 27.1689 8.47957 27.108 8.41922L20.825 2.18922C20.7033 2.06822 20.5386 2.00028 20.367 2.00022H20.3V6.86815C20.3298 7.46073 20.5928 8.01748 21.0315 8.41689C21.4703 8.81631 22.0492 9.02598 22.642 9.00015H27.3ZM19 2.00022H7.094C6.28432 1.9906 5.50388 2.30251 4.92386 2.86753C4.34384 3.43256 4.01159 4.20456 4 5.01422V26.2862C4.01159 27.0959 4.34384 27.8679 4.92386 28.4329C5.50388 28.9979 6.28432 29.3098 7.094 29.3002H24.206C25.0157 29.3098 25.7961 28.9979 26.3761 28.4329C26.9562 27.8679 27.2884 27.0959 27.3 26.2862V10.3001H22.642C21.7045 10.326 20.7949 9.97941 20.1123 9.33619C19.4297 8.69298 19.0298 7.80555 19 6.86815V2.00022ZM16.3 12.2502H15V16.8833H10.367V18.1833H15V22.8152H16.3V18.1833H20.932V16.8833H16.3V12.2502Z", className: classes.fill }, void 0) }), void 0));
        };
    }
}
UiconDocPlusFill.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    size: prop_types_1.default.number
};
UiconDocPlusFill.defaultProps = {
    size: null
};
exports.default = react_jss_1.default(uicon_doc_plus_fill_style_1.default)(UiconDocPlusFill);
//# sourceMappingURL=uicon.doc.plus.fill.js.map